export default class ProductSelectorValue {
    name = "";
    caption = "";
    description = "";
    note = "";
    disabled = false;
    selected = false;
    possible = true;
    imageAddress = "";
    imageUrl = "";
    configuration = undefined;
    configurationValue = undefined;
    get title() {
        return this.possible ? this.caption : "NICHT verfügbar! - " + this.caption;
    }
    constructor(init) {
        Object.assign(this, init);
    }
}
